$(function () {

    var $win = $(window);
    var bp = 768;
    var win_w = $win.width();

    navigation();

    function navigation() {
        var menu = $(".site-header .g-nav");
        $(".menu-button").on("click", function () {
            if($(menu).is(":hidden")){
                $(this).addClass("active");
                $(menu).slideDown(300);
            } else {
                $(this).removeClass("active");
                $(menu).slideUp(300);
            }
        });
    };

    /* ----------------------
       page setting
     ---------------------- */
    $(".home").ifExists(function (top) {
        var $slider = top.find(".mv-slider");

        $slider.on("init", function () {
            $(".slide-container").addClass("initialized");
        });

        $slider.slick({
            autoplay: true,
            autoplaySpeed: 5000,
            arrows: false,
            dots: true,
            appendDots: $(".mainvisual-wrap .controls"),
            slidesToShow: 1,
            slidesToScroll: 1
        });
    });

    $(".lineup").ifExists(function (lineup) {
        $(".trigger").on("click", function () {
            $(this).toggleClass("active");
            $(this).next(".a-text").slideToggle(300);
        });
    });

    $(".modal-area").ifExists(function (modal) {
        $(".modal-trigger").on("click", function (e) {
            e.preventDefault();
            modal.addClass("opened");
        });

        $(".modal-bg, .modal-close").on("click", function () {
            modal.removeClass("opened");
        });
    });
});

// smooth scroll
$(function () {
    const $js_scrollBtn = $(".js-scrollBtn");
	if($js_scrollBtn){
        $js_scrollBtn.on("click",function (e){
            e.preventDefault();
            const headerHeight = $(".site-header").outerHeight();
            const targetArea = $(this).attr("data-targetArea");
            const targetAreaOffsetTop = $(targetArea).offset().top
            $("html,body").animate({scrollTop:(targetAreaOffsetTop - headerHeight)},500,"swing");
        })
    }
});

jQuery.fn.ifExists = function (fn, else_fn) {
    this.length !== 0 ? fn(this) : (else_fn && else_fn());
    return this;
};


//mainvisual video
$(function() {
  $('.mainvisual-playBtn').click(function() {
      if($('#mainvisual-video')[0].paused){
        $('#mainvisual-video')[0].play();
      }
  });

 $(".mainvisual-frame").ifExists(function () {
    $('.mainvisual-playBtn').hide();
    var video = document.getElementsByTagName('video')[0];
    video.addEventListener('ended', function() {
      video.load();
      video.autoplay=false;
    $('.mainvisual-playBtn').show();
    }, false);
    $('.mainvisual-playBtn').click(function() {
      $(this).hide();
    });

  });

});

